import { Checkbox, Image, Number, Select, Style, TextInput } from '@makeswift/runtime/controls';

import { runtime } from '~/lib/makeswift/runtime';

import { ImageAdaptive } from './client';

runtime.registerComponent(ImageAdaptive, {
  type: 'image-adaptive',
  label: 'Canary / Image Adaptive',
  icon: 'image',
  props: {
    className: Style(),
    imageSrc: Image({ label: 'Image' }),
    imageAlt: TextInput({ label: 'Image alt', defaultValue: 'Image' }),
    width: Number({ label: 'Width', defaultValue: 1200, step: 1 }),
    height: Number({ label: 'Height', defaultValue: 800, step: 1 }),
    aspectRatio: Select({
      label: 'Aspect ratio',
      options: [
        { value: 'auto', label: 'Auto (use width/height)' },
        { value: '1:1', label: 'Square (1:1)' },
        { value: '4:3', label: '4:3' },
        { value: '16:9', label: 'Widescreen (16:9)' },
        { value: '3:4', label: '3:4' },
        { value: '5:6', label: '5:6' },
      ],
      defaultValue: 'auto',
    }),
    objectFit: Select({
      label: 'Object fit',
      options: [
        { value: 'cover', label: 'Cover' },
        { value: 'contain', label: 'Contain' },
        { value: 'fill', label: 'Fill' },
        { value: 'none', label: 'None' },
        { value: 'scale-down', label: 'Scale down' },
      ],
      defaultValue: 'cover',
    }),
    sizes: TextInput({
      label: 'Responsive sizes',
      defaultValue: '(min-width: 1536px) 1280px, (min-width: 1024px) 80vw, (min-width: 768px) 90vw, 100vw',
    }),
    quality: Number({ label: 'Quality', defaultValue: 75, min: 1, max: 100, step: 1 }),
    priority: Checkbox({ label: 'High priority (eager loading)', defaultValue: false }),
  },
});

